import { render, staticRenderFns } from "./SingleDependent.vue?vue&type=template&id=ffbb9100&scoped=true&"
import script from "./SingleDependent.vue?vue&type=script&lang=js&"
export * from "./SingleDependent.vue?vue&type=script&lang=js&"
import style0 from "./SingleDependent.vue?vue&type=style&index=0&id=ffbb9100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb9100",
  null
  
)

export default component.exports